<script>
    import { OBJLoader } from "three/examples/jsm/loaders/OBJLoader";
    import { DDSLoader } from "three/examples/jsm/loaders/DDSLoader";
    import { LoadingManager } from "three/src/loaders/LoadingManager";
    import mixin from "./model-mixin.vue";

    // TODO: Better way to handle texture formats
    const manager = (new LoadingManager()); // 0.122+ new api
    manager.addHandler(/\.dds$/i, new DDSLoader());

    export default {
        name: "model-obj",
        mixins: [mixin],
        props: {
            lights: {
                type: Array,
                default () {
                    return [
                        {
                            type: "HemisphereLight",
                            position: { x: 0, y: 1, z: 0 },
                            skyColor: 0xaaaaff,
                            groundColor: 0x806060,
                            intensity: 0.2
                        },
                        {
                            type: "DirectionalLight",
                            position: { x: 1, y: 1, z: 1 },
                            color: 0xffffff,
                            intensity: 0.8
                        }
                    ];
                }
            },
            smoothing: {
                type: Boolean,
                default: false
            },
            mtlPath: {
                type: String,
                default: ""
            },
            mtl: {
                type: String,
                default: ""
            }
        },
        data () {
            const objLoader = new OBJLoader(manager);

            return {
                loader: objLoader
            };
        }
    };
</script>
